const SvgMinus = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M26.88 15.68H3.84v1.28h23.04z" />
  </svg>;
export default SvgMinus;